import React from 'react'
import PreTravelContacts from '../programs/pre-travel/Contacts'

const RegisterPreTravel = () => {
  return (
    <div id='register-pre-travel' sx={{pt: '65px'}}>
        <PreTravelContacts/>
    </div>
  )
}

export default RegisterPreTravel